import React, { useState } from "react"
import { Link } from "react-router-dom"
import {Menu, X, ChevronDown} from 'lucide-react'

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [brandOpen, setBrandOpen] = useState(false)

  return (
    <nav className="bg-gray-900 text-white sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">GA</span>
            </div>
            <span className="font-bold text-lg hidden sm:block">GeneratorAutoStart</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="hover:text-orange-500 transition-colors">
              Home
            </Link>
            
            {/* Categories Dropdown */}
            <div className="relative group">
              <button className="flex items-center space-x-1 hover:text-orange-500 transition-colors">
                <span>Solutions</span>
                <ChevronDown size={16} />
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white text-gray-900 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <Link to="/solar-backup-power" className="block px-4 py-3 hover:bg-gray-100 border-b border-gray-200">
                  <div className="font-semibold text-orange-600">Solar Backup Power</div>
                  <div className="text-sm text-gray-600">Auto start for solar systems</div>
                </Link>
                <Link to="/portable-generator" className="block px-4 py-3 hover:bg-gray-100">
                  <div className="font-semibold text-orange-600">Portable Generators</div>
                  <div className="text-sm text-gray-600">Remote start kits</div>
                </Link>
              </div>
            </div>

            {/* Brands Dropdown */}
            <div className="relative group">
              <button className="flex items-center space-x-1 hover:text-orange-500 transition-colors">
                <span>Brands</span>
                <ChevronDown size={16} />
              </button>
              <div className="absolute top-full left-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <Link to="/honda" className="block px-4 py-2 hover:bg-gray-100">Honda</Link>
                <Link to="/onan" className="block px-4 py-2 hover:bg-gray-100">Onan</Link>
                <Link to="/generac" className="block px-4 py-2 hover:bg-gray-100">Generac</Link>
                <Link to="/briggs-stratton" className="block px-4 py-2 hover:bg-gray-100">Briggs & Stratton</Link>
              </div>
            </div>

            <Link to="/guides" className="hover:text-orange-500 transition-colors">
              Guides
            </Link>
            
            <Link to="/contact" className="hover:text-orange-500 transition-colors">
              Contact
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-800 transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <Link to="/" className="block py-2 hover:text-orange-500 transition-colors">
              Home
            </Link>
            
            <div>
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className="flex items-center justify-between w-full py-2 hover:text-orange-500 transition-colors"
              >
                <span>Solutions</span>
                <ChevronDown size={16} className={`transform transition-transform ${categoryOpen ? "rotate-180" : ""}`} />
              </button>
              {categoryOpen && (
                <div className="pl-4 space-y-2 mt-2">
                  <Link to="/solar-backup-power" className="block py-2 text-gray-300 hover:text-orange-500">
                    Solar Backup Power
                  </Link>
                  <Link to="/portable-generator" className="block py-2 text-gray-300 hover:text-orange-500">
                    Portable Generators
                  </Link>
                </div>
              )}
            </div>

            <div>
              <button
                onClick={() => setBrandOpen(!brandOpen)}
                className="flex items-center justify-between w-full py-2 hover:text-orange-500 transition-colors"
              >
                <span>Brands</span>
                <ChevronDown size={16} className={`transform transition-transform ${brandOpen ? "rotate-180" : ""}`} />
              </button>
              {brandOpen && (
                <div className="pl-4 space-y-2 mt-2">
                  <a href="#honda" className="block py-2 text-gray-300 hover:text-orange-500">Honda</a>
                  <a href="#onan" className="block py-2 text-gray-300 hover:text-orange-500">Onan</a>
                  <a href="#generac" className="block py-2 text-gray-300 hover:text-orange-500">Generac</a>
                  <a href="#briggs" className="block py-2 text-gray-300 hover:text-orange-500">Briggs & Stratton</a>
                </div>
              )}
            </div>

            <Link to="/guides" className="block py-2 hover:text-orange-500 transition-colors">
              Guides
            </Link>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
